function ErrorRequest() {
  return (
    <div className="done">
      <h1>Houve um erro na solicitação. Feche esta aba, volte ao bot e tente novamente.</h1>
    </div>
  );
}

export default ErrorRequest;
